<div class="login-page thm-home">
  <div class="login-page-wrapper">
    <div class="">
      <div class="login-wrapper">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 login-logo-wrapper1">
            <!--            <h4 class="login-title">Done</h4>-->
            <div *ngIf="status === 'approved'" class="action-message approved"><i class="fa fa-check-circle-o info-icon"></i>The user has been approved and welcome Email has been sent to him/her.</div>
            <div *ngIf="status === 'denied'" class="action-message denied"><i class="fa fa-times-circle-o info-icon"></i>The user addition has been denied and information sent to the creator by Email.</div>
            <div *ngIf="status === 'invalid'" class="action-message invalid"><i class="fa fa-info-circle info-icon"></i>Invalid link, Or the decision taken already.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
